import axios from "./userInstance";
import { toast } from "react-toastify";
import notifyError from "@/utils/notifyError";

interface CreateUserPayload {
  email: string;
  password: string;
  roles: string[];
}

export default async (payload: CreateUserPayload) => {
  try {
    const response = await axios.post(`/users/`, payload);
    toast.success(`User ${payload.email} created successfully`)
    return response.data || true
  } catch (error: any) {
    notifyError(error, 'Failed to create user')
    return null
  }
}
